import * as Immutable from "immutable";
import VisualizationConfig from "views/logic/aggregationbuilder/visualizations/VisualizationConfig";
export const COLORSCALES = [
  "Greys",
  "YlGnBu",
  "Greens",
  "YlOrRd",
  "Bluered",
  "RdBu",
  "Reds",
  "Blues",
  "Picnic",
  "Rainbow",
  "Portland",
  "Jet",
  "Hot",
  "Blackbody",
  "Earth",
  "Electric",
  "Viridis",
  "Cividis"
];
export default class HeatmapVisualizationConfig extends VisualizationConfig {
  constructor(colorScale, reverseScale, autoScale, zMin, zMax, useSmallestAsDefault, defaultValue) {
    super();
    this._value = {
      colorScale,
      reverseScale,
      autoScale,
      zMax,
      zMin,
      useSmallestAsDefault,
      defaultValue
    };
  }
  get colorScale() {
    return this._value.colorScale;
  }
  get reverseScale() {
    return this._value.reverseScale;
  }
  get autoScale() {
    return this._value.autoScale;
  }
  get zMin() {
    return this._value.zMin;
  }
  get zMax() {
    return this._value.zMax;
  }
  get defaultValue() {
    return this._value.defaultValue;
  }
  get useSmallestAsDefault() {
    return this._value.useSmallestAsDefault;
  }
  toBuilder() {
    return new Builder(Immutable.Map(this._value));
  }
  static create(colorScale, reverseScale, autoScale, zMin, zMax, useSmallestAsDefault, defaultValue) {
    return new HeatmapVisualizationConfig(
      colorScale,
      reverseScale,
      autoScale,
      zMin,
      zMax,
      useSmallestAsDefault,
      defaultValue
    );
  }
  static empty() {
    return new HeatmapVisualizationConfig("Viridis", false, true, void 0, void 0, false, void 0);
  }
  toJSON() {
    const {
      colorScale: color_scale,
      reverseScale: reverse_scale,
      autoScale: auto_scale,
      zMin: z_min,
      zMax: z_max,
      useSmallestAsDefault: use_smallest_as_default,
      defaultValue: default_value
    } = this._value;
    return {
      color_scale,
      reverse_scale,
      auto_scale,
      z_min,
      z_max,
      use_smallest_as_default,
      default_value
    };
  }
  static fromJSON(_type, value = {
    color_scale: "Viridis",
    reverse_scale: false,
    auto_scale: true,
    z_min: void 0,
    z_max: void 0,
    use_smallest_as_default: false,
    default_value: void 0
  }) {
    const {
      color_scale: colorScale,
      reverse_scale: reverseScale,
      auto_scale: autoScale,
      z_min: zMin,
      z_max: zMax,
      use_smallest_as_default: useSmallestAsDefault,
      default_value: defaultValue
    } = value;
    return HeatmapVisualizationConfig.create(
      colorScale,
      reverseScale,
      autoScale,
      zMin,
      zMax,
      useSmallestAsDefault,
      defaultValue
    );
  }
}
export class Builder {
  constructor(value = Immutable.Map()) {
    this.value = value;
  }
  colorScale(value) {
    return new Builder(this.value.set("colorScale", value));
  }
  reverseScale(value) {
    return new Builder(this.value.set("reverseScale", value));
  }
  autoScale(value) {
    return new Builder(this.value.set("autoScale", value));
  }
  zMin(value) {
    return new Builder(this.value.set("zMin", value));
  }
  zMax(value) {
    return new Builder(this.value.set("zMax", value));
  }
  useSmallestAsDefault(value) {
    return new Builder(this.value.set("useSmallestAsDefault", value));
  }
  defaultValue(value) {
    return new Builder(this.value.set("defaultValue", value));
  }
  build() {
    const { colorScale, reverseScale, autoScale, zMin, zMax, useSmallestAsDefault, defaultValue } = this.value.toObject();
    return new HeatmapVisualizationConfig(
      colorScale,
      reverseScale,
      autoScale,
      zMin,
      zMax,
      useSmallestAsDefault,
      defaultValue
    );
  }
}
